export const getDateFilterFromLocalStorage = (itemName: string): string[] | undefined => {
  const dateItem = localStorage.getItem(itemName);
  return dateItem ? JSON.parse(dateItem) : undefined;
};

export const saveDateFilterInLocalStorage = (range: string[], itemName: string): void => {
  localStorage.setItem(itemName, JSON.stringify(range));
};

export const getShortcutFromLocalStorage = (itemName: string): string | null => {
  return localStorage.getItem(`${itemName}-shortcut`);
};

export const saveShortcutInLocalStorage = (itemName: string, shortcut: string): void => {
  localStorage.setItem(`${itemName}-shortcut`, shortcut);
};

export const removeShortcutFromLocalStorage = (itemName: string): void => {
  localStorage.removeItem(`${itemName}-shortcut`);
};

export const getExportLimit = (): number => {
  return parseInt(localStorage.getItem('exportLimit') ?? '0', 10);
};

export const getExportUsername = (): string => {
  return localStorage.getItem('username') ?? '';
};

export const getPartnerCurrency = (): string => {
  return localStorage.getItem('partnerCurrency') ?? 'EUR';
};
